import { Injector, Injectable, runInInjectionContext } from '@angular/core'
import { AngularFireDatabase } from '@angular/fire/compat/database'
import { BehaviorSubject, Subscription } from 'rxjs'
import { IComment } from 'app/interfaces/IComment'
import { nanoid } from 'nanoid'
import { UserService } from 'app/core/user/user.service'
import { ChatContextEnum } from 'app/enums/ChatContextEnum'

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  chatContext: ChatContextEnum = ChatContextEnum.SURVEY_BUILDER
  comments$ = new BehaviorSubject<IComment[]>([])
  private commentsSubscription: Subscription | null = null

  constructor(
    private db: AngularFireDatabase,
    private userService: UserService,
    private injector: Injector
  ) {
  }

  listenToChatComments(surveyKey: string) {
    this.stopListeningToComments()
    runInInjectionContext(this.injector, () => {
      this.commentsSubscription = this.db.object<Record<string, IComment>>(`comments/${this.chatContext}/${surveyKey}`)
        .valueChanges()
        .subscribe((comments: Record<string, IComment>) => {
          try {
            runInInjectionContext(this.injector, () => {
              this.comments$.next(Object.values(comments ?? []).sort((a, b) => +new Date(a.timestamp) - +new Date(b.timestamp)))
            })
          } catch (e: unknown) {
            if (e && typeof e === 'object' && 'code' in e && (e as { code: number }).code === 205) {
              return
            }
            throw e
          }
        })
    })
  }

  stopListeningToComments(): void {
    if (this.commentsSubscription) {
      this.commentsSubscription.unsubscribe()
      this.commentsSubscription = null
    }
  }

  async saveCommentToFirebase(text: string, surveyKey: string, questionKey: string) {
    const comment: IComment = {
      key: nanoid(7),
      text,
      referenceKey: questionKey,
      timestamp: new Date(),
      userId: this.userService.user.id.toString(),
      userName: this.userService.user.name
    }
    await runInInjectionContext(this.injector, () =>
      this.db.object(`comments/${this.chatContext}/${surveyKey}/${comment.key}`).update(comment)
    )
  }

  async flushCommentsFromTestingGround() {
    await runInInjectionContext(this.injector, () =>
      this.db.object(`comments/${ChatContextEnum.TESTING}`).remove()
    )
  }

}
